import React from 'react'
import Helmet from 'react-helmet'
import config from '../utils/siteConfig'
import '../templates/base.scss'
import Layout from '../components/Layout/Layout'
import SEO from '../components/SEO'
import SoftwareDevContent from '../components/SoftwareDev/SoftwareDevContent/SoftwareDevContent'
import SoftwareDevHero from '../components/SoftwareDev/SoftwareDevHero/SoftwareDevHero'

const SoftwareDevelopment = ({ data }) => {
  const postNode = {
    title: `Software Development - ${config.siteTitle}`,
  }

  return (
    <Layout>
      <SEO postNode={postNode} pagePath="software-development" customTitle />
      <Helmet>
        <title>{`Software Development - ${config.siteTitle}`}</title>
      </Helmet>
      <SoftwareDevHero />
      <SoftwareDevContent />
    </Layout>
  )
}

export default SoftwareDevelopment
